import every from "lodash/fp/every";
import get from "lodash/fp/get";
import negate from "lodash/fp/negate";
import isNil from "lodash/fp/isNil";
import includes from "lodash/fp/includes";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import isEmpty from "lodash/fp/isEmpty";
import map from "lodash/fp/map";
import mapValues from "lodash/fp/mapValues";
import merge from "lodash/fp/merge";
import some from "lodash/fp/some";
import uniqBy from "lodash/fp/uniqBy";

import getFieldsWithIsDisabledValue from "./getFieldsWithIsDisabledValue";
import { getFlatFieldsForCustomisation } from "./getFlatFields";

const isNotNill = negate(isNil);
const mapValuesWithKey = mapValues.convert({ cap: false });

function getRequiredFieldNames(userChoiceValues) {
  return flow(
    map((fields) => {
      return flow(
        getOr({}, "validation"),
        mapValues(
          flow(
            mapValuesWithKey((validationType, fieldName) => {
              if (validationType === "isEmpty") {
                return isEmpty(userChoiceValues[fieldName]);
              }
              return false;
            }),
            some(Boolean)
          )
        ),
        merge(fields)
      )(fields);
    }),
    filter(get("isRequired")),
    getFieldsWithIsDisabledValue(userChoiceValues),
    filter(negate(get("isDisabled"))),
    filter(negate(includes("set-colors"))),
    filter(negate(includes("customizeBladePlayerName"))),
    filter(negate(includes("customizeBladePlayerNumber"))),
    filter(negate(includes("customizeBladeProfile"))),
    filter(negate(includes("Performance Radius"))),
    filter(negate(includes("customizeBladeSharpening"))),
    filter(negate(includes("Sharpening"))),
    filter(negate(includes("Additional Blades"))),
    map(get("name"))
  );
}

export default function getFormsHaveRequiredValues({
  customisation,
  customisationsVisited = [],
  userChoiceValues,
  fieldsTouched,
}) {
  const isCustomisationVisited =
    customisation.preventRender ||
    customisationsVisited.includes(customisation.id);

  const fields = flow(
    getFlatFieldsForCustomisation,
    uniqBy("name")
  )(customisation);

  const requiredFieldNames = getRequiredFieldNames(userChoiceValues)(fields);

  const hasAllFieldsBeenTouched = flow(
    every((fieldName) => includes(fieldName)(fieldsTouched))
  )(requiredFieldNames);

  const hasAllRequiredValues =
    requiredFieldNames.length === 0 ||
    requiredFieldNames.map((name) => userChoiceValues[name]).filter(isNotNill)
      .length === requiredFieldNames.length;

  if (customisation.checkUserTouchedAllFields) {
    return (
      isCustomisationVisited && hasAllRequiredValues && hasAllFieldsBeenTouched
    );
  }

  return isCustomisationVisited && hasAllRequiredValues;
}
